import { ContainerModule, interfaces } from 'inversify';
import { Configuration } from '../../configuration';
import { IConfiguration } from '../../configuration/config.types';
import { IOverlayLoaderStore, OverlayLoaderStore } from './OverlayLoader.store';

export const commonModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IOverlayLoaderStore.$).to(OverlayLoaderStore).inSingletonScope();
  bind(IConfiguration.$).to(Configuration).inSingletonScope();
});
